export const landingPageBtn = {
  '.btn': {
    marginTop: '10px',
    padding: '1rem 0',
    borderRadius: '8px',
    fontWeight: 700,
    color: '#fff',
    fontSize: '.8rem',
    boxShadow: '0 3px 0 rgba(0,0,0,.3)',
    textDecoration: 'none',
    textTransform: 'uppercase',
    '&:hover': {
      cursor: 'pointer',
    },
  },
};

export const commonLandingPageStyles = {
  fontFamily: "'Lexend', sans-serif!important",
};

export const sectionLandingPageStyles = {
  marginTop: '2rem',
  marginBottom: '2rem',
};
